import { useCallback } from 'react';
export const useCombineCallbacks = (...callbacks) => {
  return useCallback((...args) => {
    callbacks.forEach(callback => callback?.(...args));
  }, callbacks);
};